"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var ga_1 = require("../app/util/ga");
var BaseLayout_1 = __importDefault(require("../app/components/BaseLayout"));
var minifiedActions_1 = __importDefault(require("../user/components/CreateUrlModal/helpers/minifiedActions"));
var AppMargins_1 = require("../app/components/AppMargins");
var NoApiKeyGraphic_1 = __importDefault(require("./components/NoApiKeyGraphic"));
var ApiKeyGraphic_1 = __importDefault(require("./components/ApiKeyGraphic"));
var actions_1 = __importDefault(require("./actions"));
var ApiKeyModal_1 = __importDefault(require("./components/ApiKeyModal"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        apiIntegrationHeader: (_a = {
                flexGrow: 1,
                flexShrink: 0,
                marginRight: 20,
                marginTop: theme.spacing(4),
                whiteSpace: 'nowrap'
            },
            _a[theme.breakpoints.down('sm')] = {
                order: 10,
                flexBasis: '100%',
                marginTop: theme.spacing(3),
            },
            _a),
    });
});
/**
 * Show the API Integration page.
 */
var ApiIntegrationPage = function () {
    var dispatch = react_redux_1.useDispatch();
    var isLoggedIn = react_redux_1.useSelector(function (state) { return state.login.isLoggedIn; });
    var isMinified = minifiedActions_1.default();
    var hasApiKey = react_redux_1.useSelector(function (state) { return state.api.hasApiKey; });
    react_1.useEffect(function () {
        dispatch(actions_1.default.hasApiKey());
    }, [dispatch]);
    var classes = useStyles();
    react_1.useEffect(function () {
        if (isLoggedIn) {
            ga_1.GAPageView('API INTEGRATION');
            ga_1.GAEvent('api integration', 'main');
        }
    }, [isLoggedIn]);
    if (isLoggedIn) {
        return (react_1.default.createElement(BaseLayout_1.default, null,
            react_1.default.createElement(AppMargins_1.ApplyAppMargins, null,
                react_1.default.createElement(core_1.Typography, { className: classes.apiIntegrationHeader, variant: isMinified ? 'h4' : 'h3', color: "primary" }, "API Integration"),
                hasApiKey ? react_1.default.createElement(ApiKeyGraphic_1.default, null) : react_1.default.createElement(NoApiKeyGraphic_1.default, null),
                react_1.default.createElement(ApiKeyModal_1.default, null))));
    }
    return react_1.default.createElement("div", null);
};
exports.default = ApiIntegrationPage;
